import '../App.css';
import React, { useState, useEffect } from "react";
import { Row, Col, Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import image from '../images/pp-vol2.jpg';
import pdf from '../pdfs/flyerbinary.pdf'; 
import { Helmet } from 'react-helmet';

function LeibnizOnBinary() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  function scrollToElement(elementId) {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }

  function renderLinks() {
    return (
      <div style={{lineHeight: isMobile ? '1' : '', fontSize: isMobile ? '15px' : ''}}>
        <a href="https://global.oup.com/academic/product/leibniz-philosophical-papers-16771686-9780198960027" target="_blank" rel="noopener noreferrer">Order from the publisher (Oxford University Press)</a><br /><br />
        <a href="https://www.amazon.co.uk/Leibniz-Philosophical-IMetaphysics-Philosophy-Jurisprudence/dp/0198960026/" target="_blank" rel="noopener noreferrer">Order from Amazon (UK)</a><br /><br />
        <a href="https://www.amazon.com/Leibniz-Philosophical-Metaphysics-Philosophy-Jurisprudence/dp/0198960026/" target="_blank" rel="noopener noreferrer">Order from Amazon (US)</a><br /><br />
      </div>
    );
  }

  function endorsements() {
    return (
      <>
      <p>Endorsements:</p>
      
      </>
    );
  }
  
  return (
    <div>
       <Helmet>
            <title>Leibniz: Philosophical Papers 1677-1686: Metaphysics, Natural Philosophy, Ethics, and Jurisprudence</title>
            <meta name="description" content="A book authored by Lloyd Strickland on 'Philosophical Papers 1677-1686: Metaphysics, Natural Philosophy, Ethics, and Jurisprudence'" />
        </Helmet>
        <Routes>
          <Route path="/" element={
            <Container fluid className="Container">
              <Row className="main-content">
                <Col md={3} className={`LeftColumn ${isMobile ? 'mobile' : ''}`}>
                  {isMobile ? (
                    <></>
                  ) : (
                    <>
                    {renderLinks()} <hr className="centered-hr" />
                    {endorsements()}
                    </>
                  )}
                </Col>
                <Col md={8} className={`RightColumn ${isMobile ? 'mobile' : ''}`}>
                  <h2 id='top' className={`PageTitle ${isMobile ? 'mobile' : ''}`}>LEIBNIZ: PHILOSOPHICAL PAPERS 1677-1686: METAPHYSICS, NATURAL PHILOSOPHY, ETHICS, AND JURISPRUDENCE</h2>
                  {isMobile ? (
                    <>
                    {renderLinks()}
                    <p>View endorsements <span style={{color: 'blue'}} onClick={() => scrollToElement('endorsements')}>here</span></p>
                    </>
                  ) : (
                    <>
                    
                    </>
                  )}
                  <img src={image} alt="Philosophical Papers 1677-1686: Religion and Theology" style={{ float: 'left', marginRight: '20px', height: isMobile ? '220px' : '364px', width: 'auto' }} />
                  <p style={{ margin: '10px 0px 0px 0px', fontSize: '13px' }}>Published 30 April 2026, by Oxford University Press.</p><br />
                  <p>From the back cover blurb:</p>
                  This volume brings together 138 of Leibniz's writings on four key areas of philosophy - metaphysics, natural philosophy, ethics, and jurisprudence. His metaphysical writings trace the development of some of his most distinctive doctrines such as the complete concept theory of substance, pre-established harmony, the nature of human and divine freedom, and the infinite analysis of contingent truths. Leibniz's writings on natural philosophy reveal a conviction that the principles of physics ultimately depend on those of metaphysics and his efforts to develop a rational physics grounded not in experiments but in an a priori investigation of intelligible and sensible qualities, such as figure, motion, and colour. The ethical writings focus on happiness, the role of virtue, and the importance of adopting others' perspectives. Meanwhile, Leibniz's jurisprudential works centre on his ambition to create a systematic, rational foundation for law and his plan to reform legal codes by integrating Roman law with modern European jurisprudence.
<br /><br />

This collection traces the evolution and interconnection of these ideas and projects during Leibniz's formative first decade in Hanover (1677-1686), and is the most extensive collection of such writings in English to date. Strickland has returned to Leibniz's original manuscripts to produce accurate, carefully annotated translations that document textual variations, deletions, and marginalia. Of the 138 texts included, 88 appear in English for the first time, and one has never been published in any language.<br /><br />

In addition to the translations, the volume features a substantial introductory essay on Leibniz's life, work, and writings on metaphysics, natural philosophy, ethics, and jurisprudence from 1677 to 1686, along with detailed explanatory notes on each text, providing context, background, and the rationale for their dating.<br />
                  <br clear = "all" />
                  <b>TABLE OF CONTENTS</b><br /><br />
                  Abbreviations<br /><br />
                  Introduction<br />
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1. Leibniz's Life 1677-1686<br />
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2. Leibniz's Writings 1677-1686<br />
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3. Overview: Metaphysics, Natural Philosophy, Ethics, and Jurisprudence 1677-1686<br />
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4. About the Volumes, Selections of Texts, Apparatus and Typographical Conventions<br /><br />
<b>Metaphysics 1677-1686</b><br /><br />
<ol>
<li>Mostly Metaphysical Notes (1677 (?))</li>
<li>That Not All Possibles Attain Existence (1677 (?))</li>
<li>Demonstration That God Understands All Possibles (1677 (?))</li>
<li>Existence (1677 (?))</li>
<li>On Indifference of Equilibrium (1677 (?))</li>
<li>Matter and Motion Are Only Phenomena (1677-1679 (?))</li>
<li>It Is Easier to Understand God Than Comprehend Body (1677 - second half of 1702 (?))</li>
<li>Cartesianism, the Antechamber of True Philosophy (early 1677 (?))</li>
<li>The Elements of True Piety, or, on the Love of God above All Things (early 1677 - early 1678 (?))</li>
<li>How the Soul Acts on the Body (early 1677 - early 1678 (?))</li>
<li>The Distinction between Mind and Body (early 1677 - early 1678 (?))</li>
<li>On Necessary or Eternal Truths (August 1677)</li>
<li>On the Reality of Truth (August 1677)</li>
<li>The Views of Socrates Opposed to the New Stoics and Epicureans (August 1677 - September 1680 (?))</li>
<li>On Those Things Conceived through Themselves (September 1677)</li>
<li>The Axiom: There Is Nothing in the Intellect That Was Not in the Senses (October 1677 - December 1678 (?))</li>
<li>On Distinct Perception (October 1677 - December 1678 (?))</li>
<li>What Is an Idea? (autumn 1677 (?))</li>
<li>Cause of Itself (November 1677)</li>
<li>Middle Knowledge (November 1677)</li>
<li>Conversation with Steno about Freedom (27 November/7 December 1677)</li>
<li>On the Necessity of Choosing the Best (end 1677 - end 1678 (?))</li>
<li>On Proving Divine Existence (1678-1679 (?))</li>
<li>God Wills Nothing without a Reason (March-December 1678 (?))</li>
<li>Created Things Are Actually Infinite (summer 1678 - winter 1680/1681 (?))</li>
<li>On Free Will (summer 1678 - winter 1680/1681 (?))</li>
<li>On the Complete Concept of Substances (spring-summer 1679 (?))</li>
<li>Natural Philosophy and Metaphysics: Definitions and Reflections (spring 1679 - beginning of 1681 (?))</li>
<li>On Affects (10/20 and 12/22 (?) April 1679)</li>
<li>On First Truths (1680 (?))</li>
<li>On Necessity and Contingency (summer 1680 - summer 1684 (?))</li>
<li>On Freedom from Necessity in Choosing (summer 1680 - summer 1684 (?))</li>
<li>The Origin of Souls and Minds (March-June 1681 (?))</li>
<li>An Observation on the Memory and Unity of a Person (1683)</li>
<li>Whether Bodies Are Mere Phenomena (1683-1684 (?))</li>
<li>On Freedom and Grace (1683 - summer 1685 (?))</li>
<li>On Freedom and Necessity (1683 - summer 1685 (?))</li>
<li>On What Is Absurd, False, and Problematic in Descartes (1683-1685 (?))</li>
<li>On the Notion of Extension (1683-1685 (?))</li>
<li>On the Infinite and the Immense (1683-1685 (?))</li>
<li>Reflexive Action (1683-1685 (?))</li>
<li>Remarks on Mr. Descartes' <var>Method</var> and on Reverend Father Malebranche's <var>The Search after Truth</var> (1683–1685 (?))</li>
<li>On Consciousness and Memory (1683-1685 (?))</li>
<li>On the Animal's Soul (1683-1685 (?))</li>
<li>Dangerous Opinions in Descartes (1683-1685 (?))</li>
<li>On the Nature of Mind and Body (1683-1685 (?))</li>
<li>Wonders about the Nature of Corporeal Substance (28 March 1683)</li>
<li>On the Analysis of Truths and Human Judgements (summer 1683 - end of 1684 (?))</li>
<li>On Cartesian Philosophy, Geometry, and Physics (summer 1683 - winter 1684/1685 (?))</li>
<li>Descartes Lost Sight of True Analysis (summer 1683-1685 (?))</li>
<li>On the Cartesian Method of Doubt (summer 1683-1685 (?))</li>
<li>Souls Are Either Created Every Day or Are Coeval with the World (summer 1683 - winter 1684/1685 (?))</li>
<li>Difficulties Concerning the Nature and Origin of Souls (summer 1683 - winter 1684/1685 (?))</li>
<li>On the Creation of Souls and the Origin of Minds (summer 1683 - winter 1684/1685 (?))</li>
<li>On Dreams and Wakefulness (summer 1683 - winter 1685/1686 (?))</li>
<li>On the Present World (summer 1683 - winter 1685/1686 (?))</li>
<li>On the Way of Distinguishing Real Phenomena from Imaginary (summer 1683 - winter 1685/1686 (?))</li>
<li>Pleasure: An Observation against Descartes (summer 1683 - winter 1685/1686 (?))</li>
<li>Pleasure (summer 1683 - winter 1685/1686 (?))</li>
<li>We Always Perceive Our Body (summer 1683 - winter 1685/1686 (?))</li>
<li>On Nature, or the Principle That Is Analogous to the Soul (second half of 1683 - end of 1688 (?))</li>
<li>God Is Not the Soul of the World (1684-1685 (?))</li>
<li>On the Goodness of God's Works (autumn 1684 (?))</li>
<li>Meditations on Knowledge, Truth, and Ideas (autumn 1684)</li>
<li>In Bodies There Is No Perfect Shape (1685 - October 1686 (?))</li>
<li>On Rejecting the Particular Will of God, against Malebranche (winter 1685/1686 (?))</li>
<li>There Can Be Infinite Degrees among Souls (1686 (?))</li>
<li>A Vindication of Divine Justice and Human Freedom (early 1686 (?))</li>
<li>Discourse on Metaphysics (early 1686)</li>
<li>On Knowledge (April-October 1686 (?))</li>
<li>On the Freedom of the Rational Creature (autumn 1686 (?))</li>
<li>On Freedom, Fate, and God's Grace (autumn 1686 (?))</li>
<li>On the Nature of Truth, Contingency, and Indifference, and on Freedom and Predetermination (October 1686 - February 1687 (?))</li></ol><br />
<b>Natural Philosophy 1677-1686</b><br />
<ol start="74">
<li>Parts of Physics (1677 (?))</li>
<li>On the Equipollence of Cause and Effect (1677-1678 (?))</li>
<li>That Every Endeavour Is Conserved (1677-1678 (?))</li>
<li>Space and Motion are Really Relations (early 1677 (?))</li>
<li>That Motion Is a Relative Being (February 1677)</li>
<li>Pushed Bodies Act by Themselves (March 1677 - January 1678 (?))</li>
<li>On the Way to Reach the True Analysis of Bodies and the Causes of Natural Things (May 1677)</li>
<li>Animal Machine (3 October 1677)</li>
<li>The Secret of Physical Analysis (1678 (?))</li>
<li>The Laws of Nature, and Observations Concerning Motion (1678–1679 (?))</li>
<li>On Distinct and Confused Attributes of Body (mid-1678 - early 1679 (?))</li>
<li>Physical Truths (mid-1678 - early 1679 (?))</li>
<li>Conspectus for a Little Book on the Elements of Physics (mid-1678 - early 1679 (?))</li>
<li>Preface for a Little Book on the Elements of Physics (mid-1678 - early 1679 (?))</li>
<li>The Principles of Mechanics Depend on Metaphysics (summer 1678 - winter 1680/1681 (?))</li>
<li>A Plan for Writing a Natural History (June-July 1679 (?))</li>
<li>A Consultation about the Promotion of the Knowledge of Nature for the Needs of Life, and about the Formation of a Society for This Purpose (July-September 1679 (?))</li>
<li>The Human Body, Like That of Any Animal, Is a Sort of Machine (February/March 1681 - end of 1682 (?))</li>
<li>On Writing the New Elements of Medicine (February/March 1681 - end of 1682 (?))</li>
<li>A Brief Demonstration of a Remarkable Error of Descartes and Others Concerning a Law of Nature, According to Which They Claim that God Always Conserves the Same Quantity of Motion, a Law They Misuse Even in Mechanics. Communicated in a Letter Dated 6 January 1686. By G. W. L. (January 1686)</li></ol><br />
<b>Ethics 1677-1686</b><br />
<ol start="94">
<li>A Note on Placcius and Fabri (1677 - October 1690 (?))</li>
<li>On Lying and Mockery (1677-1716)</li>
<li>A Way to Heighten the Appearance of Something (1677-1716 (?))</li>
<li>On Excusing and Accusing (1677-1716 (?))</li>
<li>On Vices in Comedies (1677-1716 (?))</li>
<li>On the Art of Doing Harm (1677-1716 (?))</li>
<li>Power, Prudence, Reason of State (1677-1716 (?))</li>
<li>Reward. Honour. Praise (1677-1716 (?))</li>
<li>Supreme Happiness, Highest Good, Ultimate End: How They Differ (1677-1716 (?))</li>
<li>The Highest Good (1677-1716 (?))</li>
<li>Happiness. Beatitude (1677-1716 (?))</li>
<li>Good (1677-1716 (?))</li>
<li>The Sense of Life (October 1677-September 1680 (?))</li>
<li>On Spiritual Exercises (November 1677)</li>
<li>The Place of Others (not before 1679)</li>
<li>Importunate Reflections on Human Misery (July-early August 1679 (?))</li>
<li>On the Art of Controlling the Passions (summer 1683-summer 1684 (?))</li>
<li>Examples of Happy Men (November 1683-January 1684 (?))</li>
<li>Plan for the Education of a Prince (spring-end 1685)</li>
<li>On the Education of a Prince (spring-end 1685)</li>
<li>On Generosity (end of 1686 - start of 1687 (?))</li></ol><br />
<b>Jurisprudence 1677-1686</b><br />
<ol start="115">
<li>On Jurisprudence (April 1677 - April 1679 (?))</li>
<li>On the Enumeration of All Possible Complaints (autumn 1677 - summer 1678 (?))</li>
<li>The Method of Jurisconsults as an Exemplar for the Method of Medicine (autumn 1677 - summer 1678 (?))</li>
<li>Disputing in Form (autumn 1677-summer 1678 (?))</li>
<li>Commonplaces (autumn 1677-summer 1678 (?))</li>
<li>On Inquiring into the Reasons for Laws (summer-winter 1678/1679 (?))</li>
<li>Title 1. On Justice and Law (summer-winter 1678/1679 (?))</li>
<li>On the Interpretation, Reasons, Application, and System of Laws (summer-winter 1678/1679 (?))</li>
<li>On the Three Precepts of Eternal Law (summer-winter 1678/1679 (?))</li>
<li>Modalities and Elements of Natural Law (summer 1678-end 1679 (?))</li>
<li>Modalities and Definitions (summer 1678-end 1679 (?))</li>
<li>Rationale of the <var>Digests</var>. Prelude (end 1678-mid-1679 (?))</li>
<li>Works of Jurisprudence That a Student Should Know for Practical Application (December 1678 - September 1679)</li>
<li>Aphorisms Concerning Happiness, Wisdom, Charity, and Justice (first quarter of 1679 (?))</li>
<li>The Principles of Natural Law (first quarter of 1679 (?))</li>
<li>On the Analysis of Thoughts (first half of 1679 (?))</li>
<li>On Right and Justice (May 1679-May 1680 (?))</li>
<li>On Justice and Writing a New Code of Laws (May 1679-May 1680 (?))</li>
<li>On the Common Good (1680 (?))</li>
<li>On the Science of Natural Law (1680 (?))</li>
<li>On Reducing the Law to an Art (1680 (?))</li>
<li>The Science of Charity and the Supreme Rule of Right (1680 (?))</li>
<li>On Justice and Love and the Will of God (August 1680-end 1681 (?))</li>
<li>Preface for a New Code (August 1680-February 1685 (?))</li></ol>

                  Bibliography<br /><br />
                  Index
                  <br></br><br></br>
                  {isMobile ? (
                    <div id="endorsements">
                      <hr></hr><p style={{paddingTop: '10px'}}>Go back to the top of the page <span style={{color: 'blue'}} onClick={() => scrollToElement('top')}>here</span></p>
                      {endorsements()}
                    </div>
                  ) : (
                    <>
                    </>
                  )}
                </Col>
                <Col md={1}></Col>
              </Row>
              <Row className="footer"><h6>&copy; LLOYD STRICKLAND 2003-{new Date().getFullYear()}</h6></Row>
            </Container>
          } />
        </Routes>
      </div>
  );
}

export default LeibnizOnBinary;
